import React from 'react';
import PropTypes from 'prop-types';

import { classNames } from '../../utilities';

import { buttonLinkStylePropTypes } from './link-prop-types';
import styles from './Link.css';

export const Link = ({
  buttonLinkStyle,
  children,
  disabled,
  extraStyles,
  handleClick,
  openNewTab,
  type,
  url
}) => (
  <a
    className={classNames(
      type === 'link' ? 'link' : styles[`${buttonLinkStyle}-button-link`],
      extraStyles
    )}
    disabled={disabled}
    href={url}
    onClick={e => {
      if (disabled) {
        e.preventDefault();
      } else {
        if (handleClick) {
          handleClick();
        }

        // This gets rid of the hover styles after click
        e.target.blur();
      }
    }}
    rel={openNewTab ? 'noopener noreferrer' : null}
    target={openNewTab ? '_blank' : null}>
    {children}
  </a>
);

Link.propTypes = {
  // eslint-disable-next-line react/require-default-props
  buttonLinkStyle: buttonLinkStylePropTypes,
  /** @ignore */
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  /**
    Use this to pass styles from another component stylesheet into the
    component, e.g. `styles.extraComponentStyles`. **Please note:** we cannot
    guarantee the CSS order when compiling the bundles so we need to increase
    the specificity of the extra styles selectors using `:root` e.g.
    `:root .extra-component-styles` in the CSS file.
  */
  extraStyles: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
  openNewTab: PropTypes.bool,
  type: PropTypes.oneOf(['link', 'button']),
  url: PropTypes.string.isRequired
};

Link.defaultProps = {
  disabled: false,
  extraStyles: '',
  openNewTab: false,
  type: 'link'
};
